module.exports = __webpack_public_path__ + "static/img/t6.0db5931.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/taijia/t6.png
// module id = aj4O
// module chunks = 1